/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Iconik_Publish_Reviewers_Externals_LabelInputs */



/**
* | output |
* | --- |
* | "External reviewer emails" |
*
* @param {Iconik_Publish_Reviewers_Externals_LabelInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const iconik_publish_reviewers_externals_label = /** @type {((inputs?: Iconik_Publish_Reviewers_Externals_LabelInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Iconik_Publish_Reviewers_Externals_LabelInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("External reviewer emails")
	if (locale === "de") return /** @type {LocalizedString} */ ("External reviewer emails")
	if (locale === "it") return /** @type {LocalizedString} */ ("External reviewer emails")
	if (locale === "ru") return /** @type {LocalizedString} */ ("External reviewer emails")
	if (locale === "es") return /** @type {LocalizedString} */ ("External reviewer emails")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("External reviewer emails")
	if (locale === "ja") return /** @type {LocalizedString} */ ("External reviewer emails")
	if (locale === "hi") return /** @type {LocalizedString} */ ("External reviewer emails")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("External reviewer emails")
	return /** @type {LocalizedString} */ ("External reviewer emails")
});